module.exports = __webpack_public_path__ + "static/bg_image-02bcf9a9d81ab5f4ccf6e33406f4e044.svg";